// extracted by mini-css-extract-plugin
export default {"root":"IconClose2_root__bChcY"};